import { render, staticRenderFns } from "./routers.vue?vue&type=template&id=7c2d5cda&"
import script from "./routers.vue?vue&type=script&lang=js&"
export * from "./routers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports